import { render } from "./EventDetail.vue?vue&type=template&id=7be8e385"
import script from "./EventDetail.vue?vue&type=script&lang=js"
export * from "./EventDetail.vue?vue&type=script&lang=js"
script.render = render

export default script